const NAME = "CATALOGS";

export default NAME;
